import { Component, OnInit } from '@angular/core';

import { ACL } from '@proman/services/acl.service';
import { Dialog } from '../services/dialog.service';

import { QrLog } from '@proman/interfaces/entity-interfaces';
import { TableConfig } from '@proman/interfaces/object-interfaces';

import { EntityCreateDialogComponent } from '../dialogs/entity-create-dialog.component';
import { EntityEditDialogComponent } from '../dialogs/entity-edit-dialog.component';

@Component({
    selector: 'root-qr',
    template: `
        <div class="hero">
            <root-header></root-header>
            <div class="container">
                <pro-table [config]="tableConfig" [timeStamp]="tableTimestamp" [loadWhen]="tableConfig"></pro-table>
            </div>
        </div>
    `,
    styles: [`
        td {
            vertical-align: middle;
        }

        .container {
            margin-top: 5em;
            margin-bottom: 1em;
        }
    `]
})

export class QrComponent implements OnInit {
    query: string;
    tableConfig: TableConfig;
    tableTimestamp: number;

    constructor(
      private Dialog: Dialog,
      public ACL: ACL,
    ) {
    }

    ngOnInit() {
      this.setTableConfig()
    }

    refresh = () => this.tableTimestamp = new Date().getTime();

    setTableConfig() {
        this.tableConfig = {
            entity: 'qr_log',
            aclRoot: null,
            tableId: 'qr_log',
            fields: [
                {
                    name: 'qr_id',
                    key: 'id',
                },
                {
                    name: 'redirect_url',
                    key: 'redirectUrl',
                },
                {
                    name: 'created_at',
                    key: 'createdAt',
                    formatter: 'dateTime',
                    formatterConfig: '_datetime_js',
                }
            ],
            extraParameters: {},
            preventFixedHeader: true,
            rowButtons: [
                {
                    icon: 'edit',
                    theme: 'accent',
                    acl: null,
                    tooltip: 'edit',
                    callback: (row: QrLog) => this.editQr(row),
                },
            ]
        }
    }

    create() {
        this.Dialog.open(EntityCreateDialogComponent, {
            entity: 'qr_log',
            mainField: {
                key: 'redirectUrl',
                config: { label: 'redirect_url', required: true },
            },
        }).then(() => this.refresh());
    }

    editQr = (item: QrLog) => {
        this.Dialog.open(EntityEditDialogComponent, {
            item,
            entity: 'qr_log',
            mainField: {
                key: 'redirectUrl',
                config: { label: 'redirect_url', required: true },
            }
        }).then(() => this.refresh());
    };
}
